/*
=========================================================
* Material Kit 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { FC, ReactNode, forwardRef, useState } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Divider from "@mui/material/Divider";
import Slide from "@mui/material/Slide";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
const filter = createFilterOptions<any>();

// @mui icons
import CloseIcon from "@mui/icons-material/Close";

// Material Kit 2 PRO React components
import MDBox from "../MDBox";
import MDButton from "../MDButton";
import MDTypography from "../MDTypography";
import MDInput from "../MDInput";

interface Props {
    open: boolean;
    defaultValue: string;
    options: Array<String>;
    label: string;
    onChange: Function | null;
    boxProps: any;
};

const MDSelect: FC<Props | any> = ({defaultValue, options, label, boxProps, ...rest}) => {
    const props = {...rest};
    let required = false;
    if(props.hasOwnProperty("required")){
        required = props.required;
    }
    return (
        <MDBox className="MuiAutocomplete-root-container" {...boxProps}>
            <Autocomplete
                defaultValue={defaultValue}
                options={options}
                getOptionLabel={(option: any) => {
                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                      return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    // Regular option
                    return option.label;
                }}
                renderOption={(props: any, option: any) => {
                    const { key, ...optionProps } = props;
                    return (
                        <li key={key} {...optionProps}>
                            {
                                typeof option === 'string' ?
                                    option
                                :
                                    option.label
                            }
                        </li>
                    );
                }}
                filterOptions={(options: any, params: any) => {
                    const filtered = filter(options, params);
                    // const { inputValue } = params;
                    // const isExisting = options.some((option) => inputValue === option.label);
                    // if (inputValue !== '' && !isExisting) {
                    //     filtered.push({
                    //         inputValue,
                    //         label: `Add "${inputValue}"`,
                    //     });
                    // }
                    return filtered;
                }}
                renderInput={(params) => <MDInput {...params} required={required} variant="outlined" label={label} />}
                {...rest}
            />
        </MDBox>
    );
};

export default MDSelect;
